export default function Website() {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-gray-900">Website</h1>
    </div>
  );
}
